module.exports = __webpack_public_path__ + "img/Brown.ba26bd9a.png";